import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import Api from '../servicios/api';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'

const ListarUbicacion = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [ubicaciones, setUbicacion] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(Api+"?consultarUbicacion")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setUbicacion(datosRespuesta);
        })
        .catch(console.log)
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
    }

    const borrarRegistro = () => {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});

        fetch(Api+"?borrarUbicacion="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Ubicación eliminada correctamente.'
                });
                cargarDatos();
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'No es posible eliminar esta ubicación.'
                });
            }
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Ubicaciones</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-ubicacion" primario="true">Agregar Ubicacion</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                {ubicaciones.success === 0 ?
                <p className='ms-3'>No hay información para mostrar.</p>
                :
                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        ubicaciones.map(
                                            (ubicacion)=>(
                                                <tr key={ubicacion.Ubi_ID}>
                                                    <td>{ubicacion.Ubi_Nombre}</td>
                                                    <td>
                                                        <ContenedorBotonesLista>
                                                            <BotonEditar title="Actualizar Ubicación" as={Link} to={"/editar-ubicacion/"+ubicacion.Ubi_ID}>
                                                                <IconoEditar />
                                                            </BotonEditar>
                                                            
                                                            <BotonEliminar title="Eliminar Ubicación" onClick={() => handleModal(ubicacion.Ubi_ID)}>
                                                                <IconoBorrar />
                                                            </BotonEliminar>
                                                        </ContenedorBotonesLista>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader="Eliminar Ubicación"
                        mensajeBody="¿Está seguro de eliminar la ubicación?"
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}
 
export default ListarUbicacion;